import { Controller } from "@hotwired/stimulus"

// Animates the AI loading messages with a typewriter effect and cycling through steps
export default class extends Controller {
  static targets = ["message", "messageContainer", "step", "connector"]

  // Messages to cycle through - will be replaced by actual translations
  messages = [
    "Analyzing your crop monitoring requirements...",
    "Understanding pest and disease patterns...",
    "Designing optimal field layout...",
    "Configuring measurement thresholds...",
    "Optimizing for easy data entry...",
    "Building custom validation rules...",
    "Generating field descriptions...",
    "Finalizing your monitoring form..."
  ]

  connect() {
    this.currentStep = 0
    this.currentMessageIndex = 0
    
    // Get messages from data attribute if available, otherwise use defaults
    const messagesAttr = this.element.dataset.aiLoadingAnimationMessages
    if (messagesAttr) {
      try {
        this.messages = JSON.parse(messagesAttr)
      } catch (e) {
        // Use defaults
      }
    }

    // Start cycling through messages
    this.startMessageCycle()
    
    // Start step progression
    this.startStepProgression()
  }

  disconnect() {
    if (this.messageInterval) {
      clearInterval(this.messageInterval)
    }
    if (this.stepTimeout) {
      clearTimeout(this.stepTimeout)
    }
  }

  startMessageCycle() {
    // Change message every 3 seconds
    this.messageInterval = setInterval(() => {
      this.currentMessageIndex = (this.currentMessageIndex + 1) % this.messages.length
      this.animateMessage(this.messages[this.currentMessageIndex])
    }, 3000)
  }

  startStepProgression() {
    // Progress through steps at intervals
    const stepDuration = 4000 // 4 seconds per step
    
    const progressStep = () => {
      if (this.currentStep < this.stepTargets.length) {
        const step = this.stepTargets[this.currentStep]
        
        // Animate the step becoming active
        step.classList.remove("bg-base-300", "text-base-content/40")
        step.classList.add("bg-primary", "text-primary-content")
        step.innerHTML = '<span class="loading loading-spinner loading-xs"></span>'
        
        // Animate the connector before it
        if (this.currentStep > 0 && this.connectorTargets[this.currentStep - 1]) {
          this.connectorTargets[this.currentStep - 1].classList.remove("bg-base-300")
          this.connectorTargets[this.currentStep - 1].classList.add("bg-primary")
        }
        
        // Mark previous step as complete
        if (this.currentStep > 0) {
          const prevStep = this.stepTargets[this.currentStep - 1]
          prevStep.innerHTML = '<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path></svg>'
        }
        
        this.currentStep++
        
        if (this.currentStep < this.stepTargets.length) {
          this.stepTimeout = setTimeout(progressStep, stepDuration)
        }
      }
    }
    
    // Start after initial delay
    this.stepTimeout = setTimeout(progressStep, stepDuration)
  }

  animateMessage(newMessage) {
    if (!this.hasMessageTarget) return
    
    const messageEl = this.messageTarget
    
    // Fade out
    messageEl.style.opacity = "0"
    messageEl.style.transform = "translateY(-10px)"
    
    setTimeout(() => {
      messageEl.textContent = newMessage
      messageEl.style.opacity = "1"
      messageEl.style.transform = "translateY(0)"
    }, 200)
  }
}
